import { useActivityMatches } from "PFApp/activities/show/hooks/use_activity_matches";
import { useCurrentActivity } from "PFApp/activities/show/hooks/use_current_activity";
import { useMatchesActions } from "PFApp/activities/show/store/matches";
import {
  FiltersV2StoreContextProvider,
  useApiFilters,
  useFiltersV2MetaAutoUpdate
} from "PFApp/components/filters_v2";
import { FiltersV2StorePage } from "PFApp/components/filters_v2/stores/filters_v2_store/filters_v2_store.types";
import { Inline } from "PFComponents/containers";
import { useEffect, useRef } from "react";
import { useTranslation } from "react-i18next";

import { MatchesPanel, MatchesSidePanel } from "./parts";
import { MatchesActivityClosed } from "./parts/matches_activity_closed";

const ActivityMatchesContent = () => {
  const { t } = useTranslation("activities");
  const scrollableContainerRef = useRef<HTMLDivElement>(null);

  const { matchesMeta } = useActivityMatches();
  const { updateMatchesParams } = useMatchesActions();
  const { apiFilters } = useApiFilters({ sendDefaultsAsUndefined: false, sendEmptyAsUndefined: false });
  useFiltersV2MetaAutoUpdate(matchesMeta);

  useEffect(() => {
    updateMatchesParams({ filters: apiFilters, page: 1 });
  }, [apiFilters, updateMatchesParams]);

  return (
    <Inline
      ref={scrollableContainerRef}
      gap="spacingLg"
      role="tabpanel"
      aria-label={t("show.tabs.matches")}
      qaId="ActivityPage.matchesTab"
    >
      <MatchesSidePanel scrollableContainerRef={scrollableContainerRef} />
      <MatchesPanel />
    </Inline>
  );
};

export const ActivityMatches = () => {
  const activity = useCurrentActivity();

  if (activity.state === "complete") {
    return <MatchesActivityClosed activity={activity} />;
  }

  return (
    <FiltersV2StoreContextProvider name={FiltersV2StorePage.ActivityShortlistPage}>
      <ActivityMatchesContent />
    </FiltersV2StoreContextProvider>
  );
};
